<template>
    <div class="title-section alert alert-secondary p-1 shadow-sm">
        <div class='trending-products p-2'>
            <h3 class="text-capitalize">Viral Products</h3>
            <p v-if="para" v-html="para"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViralProductUpdateTrendNotice",
    props: {
      para: { default: '' },
    },
}
</script>
